import React from "react";
import SEO from "../components/SEO";
import features from "../data/features.json";

export default function Feature() {
  return (
    <div className="container my-5">
      <SEO
        title="Top Software Features"
        description="Explore AI-powered automation, cloud scalability, and enterprise-grade security built into every 100 Eyes Technologies solution. Designed for high-performance business growth."
        keywords="software features, AI automation, data analytics, cloud systems, enterprise security, 100 eyes technologies"
        image="https://100eyestechnologies.com/img/feature.webp"
      >
        {/* Preserve OG tags for fine control */}
        <meta property="og:title" content="Top Software Features | 100 Eyes Technologies" />
        <meta property="og:description" content="Smart, secure, and scalable — explore the unique features that make 100 Eyes Technologies solutions stand out." />
        <meta property="og:url" content="https://100eyestechnologies.com/features" />
        <meta property="og:image" content="https://100eyestechnologies.com/img/feature.webp" />
      </SEO>

      <div className="text-center mb-5">
        <h1 className="fw-bold">Our Software Features</h1>
        <p className="lead text-muted">
          Smart, Secure, and Scalable — Engineered to Empower Digital Growth
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature) => (
          <div key={feature.id} className="col-md-6 col-lg-4">
            <div className="p-4 border rounded-3 shadow-sm h-100">
              <div className="fs-1 mb-2">{feature.icon}</div>
              <h5 className="fw-bold">{feature.title}</h5>
              <p>{feature.short}</p>
              <p className="text-muted small">{feature.details}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
